function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReleasesIncluded = function SvgReleasesIncluded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2389_1359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67808 72.6276C8.30514 72.6276 8 72.3224 8 71.9495V61.7783C8 61.4054 8.30514 61.1002 8.67808 61.1002C9.05102 61.1002 9.35616 61.4054 9.35616 61.7783V71.9495C9.35616 72.3224 9.05102 72.6276 8.67808 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5774 79.4084C14.2044 79.4084 13.8993 79.1032 13.8993 78.7303V54.9975C13.8993 54.6246 14.2044 54.3195 14.5774 54.3195C14.9503 54.3195 15.2554 54.6246 15.2554 54.9975V78.7303C15.2554 79.1032 14.9503 79.4084 14.5774 79.4084Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4834 78.0521C20.1104 78.0521 19.8053 77.747 19.8053 77.3741V56.3536C19.8053 55.9807 20.1104 55.6755 20.4834 55.6755C20.8563 55.6755 21.1615 55.9807 21.1615 56.3536V77.3741C21.1615 77.747 20.8563 78.0521 20.4834 78.0521Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3827 72.6276C26.0098 72.6276 25.7047 72.3224 25.7047 71.9495V61.7783C25.7047 61.4054 26.0098 61.1002 26.3827 61.1002C26.7557 61.1002 27.0608 61.4054 27.0608 61.7783V71.9495C27.0608 72.3224 26.7557 72.6276 26.3827 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.282 84.1549C31.9091 84.1549 31.6039 83.8498 31.6039 83.4768V50.251C31.6039 49.878 31.9091 49.5729 32.282 49.5729C32.655 49.5729 32.9601 49.878 32.9601 50.251V83.4768C32.9601 83.8498 32.655 84.1549 32.282 84.1549Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1881 78.0521C37.8151 78.0521 37.51 77.747 37.51 77.3741V56.3536C37.51 55.9807 37.8151 55.6755 38.1881 55.6755C38.561 55.6755 38.8662 55.9807 38.8662 56.3536V77.3741C38.8662 77.747 38.561 78.0521 38.1881 78.0521Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0874 76.018C43.7144 76.018 43.4093 75.7128 43.4093 75.3399V58.3879C43.4093 58.015 43.7144 57.7098 44.0874 57.7098C44.4603 57.7098 44.7655 58.015 44.7655 58.3879V75.3399C44.7655 75.7128 44.4603 76.018 44.0874 76.018Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9934 72.6276C49.6205 72.6276 49.3154 72.3224 49.3154 71.9495V61.7783C49.3154 61.4054 49.6205 61.1002 49.9934 61.1002C50.3664 61.1002 50.6715 61.4054 50.6715 61.7783V71.9495C50.6715 72.3224 50.3664 72.6276 49.9934 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8927 75.3399C55.5198 75.3399 55.2147 75.0348 55.2147 74.6618V59.066C55.2147 58.6931 55.5198 58.3879 55.8927 58.3879C56.2657 58.3879 56.5708 58.6931 56.5708 59.066V74.6618C56.5708 75.0348 56.2657 75.3399 55.8927 75.3399Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.792 78.0521C61.419 78.0521 61.1139 77.747 61.1139 77.3741V56.3536C61.1139 55.9807 61.419 55.6755 61.792 55.6755C62.1649 55.6755 62.47 55.9807 62.47 56.3536V77.3741C62.47 77.747 62.1649 78.0521 61.792 78.0521Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6981 84.833C67.3252 84.833 67.02 84.5278 67.02 84.1549V49.5729C67.02 49.1999 67.3252 48.8948 67.6981 48.8948C68.071 48.8948 68.3762 49.1999 68.3762 49.5729V84.1549C68.3762 84.5278 68.071 84.833 67.6981 84.833Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5973 77.3741C73.2244 77.3741 72.9193 77.0689 72.9193 76.696V57.0317C72.9193 56.6588 73.2244 56.3536 73.5973 56.3536C73.9703 56.3536 74.2754 56.6588 74.2754 57.0317V76.696C74.2754 77.0689 73.9703 77.3741 73.5973 77.3741Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4966 72.6276C79.1237 72.6276 78.8185 72.3224 78.8185 71.9495V61.7783C78.8185 61.4054 79.1237 61.1002 79.4966 61.1002C79.8696 61.1002 80.1747 61.4054 80.1747 61.7783V71.9495C80.1747 72.3224 79.8696 72.6276 79.4966 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4027 72.6276C85.0297 72.6276 84.7246 72.3224 84.7246 71.9495V61.7783C84.7246 61.4054 85.0297 61.1002 85.4027 61.1002C85.7756 61.1002 86.0808 61.4054 86.0808 61.7783V71.9495C86.0808 72.3224 85.7756 72.6276 85.4027 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.302 72.6276C90.929 72.6276 90.6239 72.3224 90.6239 71.9495V61.7783C90.6239 61.4054 90.929 61.1002 91.302 61.1002C91.6749 61.1002 91.9801 61.4054 91.9801 61.7783V71.9495C91.9801 72.3224 91.6749 72.6276 91.302 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.208 79.4084C96.8351 79.4084 96.53 79.1032 96.53 78.7303V54.9975C96.53 54.6246 96.8351 54.3195 97.208 54.3195C97.581 54.3195 97.8861 54.6246 97.8861 54.9975V78.7303C97.8861 79.1032 97.581 79.4084 97.208 79.4084Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.107 78.0521C102.734 78.0521 102.429 77.747 102.429 77.3741V56.3536C102.429 55.9807 102.734 55.6755 103.107 55.6755C103.48 55.6755 103.785 55.9807 103.785 56.3536V77.3741C103.785 77.747 103.48 78.0521 103.107 78.0521Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.007 72.6276C108.634 72.6276 108.329 72.3224 108.329 71.9495V61.7783C108.329 61.4054 108.634 61.1002 109.007 61.1002C109.38 61.1002 109.685 61.4054 109.685 61.7783V71.9495C109.685 72.3224 109.38 72.6276 109.007 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.913 84.1549C114.54 84.1549 114.235 83.8498 114.235 83.4768V50.251C114.235 49.878 114.54 49.5729 114.913 49.5729C115.286 49.5729 115.591 49.878 115.591 50.251V83.4768C115.591 83.8498 115.286 84.1549 114.913 84.1549Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.711 76.018C126.338 76.018 126.033 75.7128 126.033 75.3399V58.3879C126.033 58.015 126.338 57.7098 126.711 57.7098C127.084 57.7098 127.389 58.015 127.389 58.3879V75.3399C127.389 75.7128 127.084 76.018 126.711 76.018Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.617 72.6276C132.244 72.6276 131.939 72.3224 131.939 71.9495V61.7783C131.939 61.4054 132.244 61.1002 132.617 61.1002C132.99 61.1002 133.295 61.4054 133.295 61.7783V71.9495C133.295 72.3224 132.99 72.6276 132.617 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.517 75.3399C138.144 75.3399 137.839 75.0348 137.839 74.6618V59.066C137.839 58.6931 138.144 58.3879 138.517 58.3879C138.89 58.3879 139.195 58.6931 139.195 59.066V74.6618C139.195 75.0348 138.89 75.3399 138.517 75.3399Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.423 78.0521C144.05 78.0521 143.745 77.747 143.745 77.3741V56.3536C143.745 55.9807 144.05 55.6755 144.423 55.6755C144.796 55.6755 145.101 55.9807 145.101 56.3536V77.3741C145.101 77.747 144.796 78.0521 144.423 78.0521Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.322 84.833C149.949 84.833 149.644 84.5278 149.644 84.1549V49.5729C149.644 49.1999 149.949 48.8948 150.322 48.8948C150.695 48.8948 151 49.1999 151 49.5729V84.1549C151 84.5278 150.695 84.833 150.322 84.833Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.221 77.3741C155.848 77.3741 155.543 77.0689 155.543 76.696V57.0317C155.543 56.6588 155.848 56.3536 156.221 56.3536C156.594 56.3536 156.899 56.6588 156.899 57.0317V76.696C156.899 77.0689 156.594 77.3741 156.221 77.3741Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.127 72.6276C161.754 72.6276 161.449 72.3224 161.449 71.9495V61.7783C161.449 61.4054 161.754 61.1002 162.127 61.1002C162.5 61.1002 162.805 61.4054 162.805 61.7783V71.9495C162.805 72.3224 162.5 72.6276 162.127 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.027 72.6276C167.654 72.6276 167.349 72.3224 167.349 71.9495V61.7783C167.349 61.4054 167.654 61.1002 168.027 61.1002C168.4 61.1002 168.705 61.4054 168.705 61.7783V71.9495C168.705 72.3224 168.4 72.6276 168.027 72.6276Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4608 98.9641C107.687 98.9641 123.273 83.378 123.273 64.1516C123.273 44.9251 107.687 29.339 88.4608 29.339C69.2344 29.339 53.6483 44.9251 53.6483 64.1516C53.6483 83.378 69.2344 98.9641 88.4608 98.9641Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4608 99.31C69.0745 99.31 53.3092 83.5379 53.3092 64.1584C53.3092 44.7789 69.0745 29 88.4608 29C107.847 29 123.612 44.7721 123.612 64.1516C123.612 83.5311 107.84 99.3032 88.4608 99.3032V99.31ZM88.4608 29.6781C69.4543 29.6781 53.9873 45.1451 53.9873 64.1516C53.9873 83.1582 69.4543 98.6251 88.4608 98.6251C107.467 98.6251 122.934 83.1582 122.934 64.1516C122.934 45.1451 107.467 29.6781 88.4608 29.6781Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4608 78.9812C96.651 78.9812 103.29 72.3418 103.29 64.1516C103.29 55.9615 96.651 49.322 88.4608 49.322C80.2707 49.322 73.6312 55.9615 73.6312 64.1516C73.6312 72.3418 80.2707 78.9812 88.4608 78.9812Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4608 79.3203C80.1001 79.3203 73.2922 72.5191 73.2922 64.1517C73.2922 55.7842 80.0933 48.983 88.4608 48.983C96.8283 48.983 103.629 55.7842 103.629 64.1517C103.629 72.5191 96.8283 79.3203 88.4608 79.3203ZM88.4608 49.6611C80.473 49.6611 73.9703 56.1639 73.9703 64.1517C73.9703 72.1394 80.473 78.6422 88.4608 78.6422C96.4486 78.6422 102.951 72.1394 102.951 64.1517C102.951 56.1639 96.4486 49.6611 88.4608 49.6611Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4608 67.3725C90.2396 67.3725 91.6817 65.9305 91.6817 64.1517C91.6817 62.3728 90.2396 60.9308 88.4608 60.9308C86.682 60.9308 85.2399 62.3728 85.2399 64.1517C85.2399 65.9305 86.682 67.3725 88.4608 67.3725Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4608 67.7183C86.4944 67.7183 84.9009 66.1181 84.9009 64.1584C84.9009 62.1988 86.5011 60.5985 88.4608 60.5985C90.4204 60.5985 92.0207 62.1988 92.0207 64.1584C92.0207 66.1181 90.4204 67.7183 88.4608 67.7183ZM88.4608 61.2698C86.8673 61.2698 85.579 62.5649 85.579 64.1516C85.579 65.7383 86.8741 67.0335 88.4608 67.0335C90.0475 67.0335 91.3426 65.7383 91.3426 64.1516C91.3426 62.5649 90.0475 61.2698 88.4608 61.2698Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3119 50.2239C69.0135 50.2239 68.7152 50.129 68.4643 49.9256C67.8812 49.4577 67.7862 48.6033 68.2541 48.0202C73.1973 41.8429 80.5612 38.2965 88.4608 38.2965C89.2067 38.2965 89.817 38.9068 89.817 39.6527C89.817 40.3986 89.2067 41.0088 88.4608 41.0088C81.3885 41.0088 74.7976 44.1822 70.3765 49.7086C70.1052 50.0408 69.712 50.2171 69.3187 50.2171L69.3119 50.2239Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2389_1359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.705,
    height: 70.31,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(8 29)"
  }))));
};
export default SvgReleasesIncluded;